import { useTheme } from "@mui/material";
import SimilarWebLogoImage from "assets/images/SimilarWeb-Logo.svg";

export default function SimilarWebLogo({ fontSize }) {
  const { palette, shape } = useTheme();

  return (
    <img
      style={{
        height: fontSize,
        display: "block",
        backgroundColor: palette.common.white,
        borderRadius: shape.borderRadius / 2,
        padding: shape.borderRadius / 4,
      }}
      src={SimilarWebLogoImage}
      alt="Similar Web"
    />
  );
}
